/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const wishlist = {
  wishlist: {
    empty: 'Todavía no hay productos en tu lista de deseos',
    itemRemoved: 'Se ha eliminado el elemento seleccionado.',
    caption: 'Contenido de la lista de deseos.',
  },
};
